import {TypeOfWorkMenu} from '../controls/task/TypeOfWorkMenu'
import TableCellRenderer from '../table/TableCellRenderer'
import {arrayToMap} from '../atUtils'
import TypeOfWorkButton from '../controls/task/TypeOfWorkButton'
import $ from 'jquery'

export default function TaskBillingTypeCellRenderer()
{}

TaskBillingTypeCellRenderer.prototype = _.create(TableCellRenderer.prototype);

TaskBillingTypeCellRenderer.BILLING_TYPE_NOT_SELECTED_VALUE = -1;

TaskBillingTypeCellRenderer.prototype.init = function( billingTypes, defaultBillingTypeId, changesCallback, scrollableContainer )
{
    TableCellRenderer.call( this );
    this.billingTypesMap = arrayToMap(billingTypes);
    this.defaultBillingTypeId = defaultBillingTypeId;
    this.changesCallback = changesCallback;
    this.scrollableContainer = scrollableContainer;
    return this;
};

TaskBillingTypeCellRenderer.prototype.generateContent = function(cell) {
    if (cell.getValue() == null)
        cell.setValue(this.defaultBillingTypeId)

    let selectedBillingTypeExists = this.billingTypesMap[cell.getValue()]
    if (!selectedBillingTypeExists)
        cell.setValue(TaskBillingTypeCellRenderer.BILLING_TYPE_NOT_SELECTED_VALUE)

    let typeOfWorkEditor = new TypeOfWorkButton({
        editable: true,
        showCategory: false,
        typeOfWorkMenu: new TypeOfWorkMenu({
            additionalClass: 'typeOfWorkEditorMenu addNewTasks',
        }).init($(cell.getCellEl())),
        positionParams: {
            within: this.scrollableContainer,
            collision: 'fit',
            my: 'right top',
            at: 'left top',
        },
        onTypeOfWorkChangedCb: (newTypeOfWorkId) => {
            cell.setValue(newTypeOfWorkId)
            cell.updateUI()
            this.changesCallback(cell)
        }
    }).init($(cell.getCellEl()))

    typeOfWorkEditor.setState({
        typeOfWorkId: cell.getValue(),
    })
    cell.typeOfWorkEditor = typeOfWorkEditor;

    if (!selectedBillingTypeExists)
        cell.updateUI()
}

TaskBillingTypeCellRenderer.prototype.updateUI = function( cell )
{
    TableCellRenderer.prototype.updateUI.call( this, cell );

    cell.typeOfWorkEditor.setState({
        typeOfWorkId: cell.getValue(),
        typeOfWorkName: cell.getValue() !== TaskBillingTypeCellRenderer.BILLING_TYPE_NOT_SELECTED_VALUE ?
                        this.billingTypesMap[cell.getValue()].name : '',
    })

    if ( cell.isValid() )
        $( cell.getCellEl() ).removeClass( "error" );
    else
        $( cell.getCellEl() ).addClass( "error" );
};

TaskBillingTypeCellRenderer.prototype.updateBillingTypes = function( billingTypes )
{
    this.billingTypesMap = billingTypes ? arrayToMap(billingTypes) : {}
};

TaskBillingTypeCellRenderer.prototype.getCellClassName = function( cell )
{
    return ["billingTypeCell"];
};



// WEBPACK FOOTER //
// ./web/js/addNewTasks/TaskBillingTypeCellRenderer.js